// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"221":"bbb66c05","328":"bbb66c05"}[chunkId] + ".css";
};